import React from "react";
import { Box } from "@mui/material";
import styles from "../../styles";
import Statistis from "./Statistics";
import ImageCarousel from "./ImageCarousel";
import { getImageSrc } from "../../../../utils/CommonFunction";
export default function ProjectOverview({ details }) {
  return (
    <>
      <div style={styles.overview_section}>
        <div style={{ ...styles.section_1, ...styles.columnFlex }}>
          <ImageCarousel details={details} />
          <Statistis details={details} />
          {details?.tags && (
            <div style={{ ...styles.columnFlex, marginTop: "2vh" }}>
              <div style={styles.section_heading}>Package Tags</div>
              <h3
                style={{
                  ...styles.rowFlex,
                  ...styles.section_sub_heading,
                  gap: "15px",
                }}
              >
                {details?.tags?.map((tag, index) => (
                  <div
                    style={{
                      backgroundColor: "#17204f",
                      color: "#fff",
                      padding: ".9vh 1vw",
                      margin: ".3vh .1vw",
                      width: "fit-content",
                      borderRadius: "18px",
                      fontSize: "14px",
                    }}
                    key={index}
                  >
                    {tag?.name}
                  </div>
                ))}
              </h3>
            </div>
          )}
          <div style={{ ...styles.columnFlex, marginTop: "2vh" }}>
            <div style={styles.section_heading}>Description</div>
            <h3 style={styles.section_sub_heading}>{details?.description}</h3>
          </div>
        </div>
        <div
          style={{
            ...styles.section_2,
            ...styles.columnFlex,
            gap: "20px",
          }}
        >
          <div style={styles.section_heading}>Members</div>
          <div style={styles.columnFlex}>
            <h3 style={styles.section_sub_heading}>Owner</h3>
            <div>
              <Box display="flex" alignItems="center">
                {details?.owner && (
                  <Box
                    component="img"
                    src={getImageSrc(details?.owner?.profileUrl)}
                    alt="Project Icon"
                    sx={{
                      width: 35,
                      height: 35,
                      borderRadius: "50%",
                      boxShadow: "0px 4px 2.67px 0px #00000026",
                      marginRight: 1,
                    }}
                  />
                )}
                {details?.owner?.companyName}
              </Box>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
